/**
 * Pantalla de login.
**/

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/Login.css";
import MixrealLogo from "../MixrealLogo.png";
import GoogleIcon from "../assets/icons/google.png";
import MicrosoftIcon from "../assets/icons/microsoft.png";
import FacebookIcon from "../assets/icons/facebook.png";
import { Mail, LockKeyhole, Eye, EyeOff } from "lucide-react";
import {
  auth, db, googleProvider,
  signInWithPopup, signInWithEmailAndPassword,
  microsofProvider, facebookProvider,
  setPersistence, browserSessionPersistence,
} from "../db/FirebaseConfig";
import { doc, setDoc, getDoc } from 'firebase/firestore';


const Login = () => {
  /*********************************** VARIABLES DE COMPONENTE ***********************************/
  /***********************************************************************************************/
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  /***********************************************************************************************/
  /***********************************************************************************************/

  /*********************************** FUNCIONES DE COMPONENTE ***********************************/
  /***********************************************************************************************/
  //cambia entre ver la contraseña y no verla
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  //Función auxiliar para crear el doc en /users/{uid} en Firebase
  const createUserDoc = async (user, displayName) => {
    await setDoc(doc(db, 'users', user.uid), {
      uid: user.uid,
      display_name: displayName || user.displayName || '',
      email: user.email || '',
      photoURL: user.photoURL || '',
      codigoVinculacion: 0,
    });
  };

  //Gestiona el login mediante cuenta de Google (OCULTO POR AHORA)
  const handleGoogleLogin = async () => {
    try {
      //la sesión sólo dura hasta que se cierra el browser
      await setPersistence(auth, browserSessionPersistence);

      const result = await signInWithPopup(auth, googleProvider);
      //una vez loggeado se navega a la página principal
      navigate("/");

      //registrar en colección 'users' si no existen las credenciales
      const userDocRef = doc(db, "users", result.user.uid);
      const userDoc = await getDoc(userDocRef);
      if (!userDoc.exists()) {
        console.log("Añadiendo doc a firestore del nuevo usuario...");
        createUserDoc(result.user);
      }
    } catch (error) {
      setError(error.message);
    }
  };

  //Gestiona el login mediante cuenta de Microsoft (NO IMPLEMENTADO)
  const handleMicrosoftLogin = async () => {
    try {
      //la sesión sólo dura hasta que se cierra el browser
      await setPersistence(auth, browserSessionPersistence);

      const result = await signInWithPopup(auth, microsofProvider);
      //una vez loggeado se navega a la página principal
      navigate("/");

      //registrar en colección 'users' si no existen las credenciales
      const userDocRef = doc(db, "users", result.user.uid);
      const userDoc = await getDoc(userDocRef);
      if (!userDoc.exists()) {
        console.log("Añadiendo doc a firestore del nuevo usuario...");
        createUserDoc(result.user);
      }
    } catch (error) {
      setError(error.message);
    }
  };

  //Gestiona el login mediante cuenta de Facebook (NO IMPLEMENTADO)
  const handleFacebookLogin = async () => {
    try {
      //la sesión sólo dura hasta que se cierra el browser
      await setPersistence(auth, browserSessionPersistence);

      const result = await signInWithPopup(auth, facebookProvider);
      //una vez loggeado se navega a la página principal
      navigate("/");

      //registrar en colección 'users' si no existen las credenciales
      const userDocRef = doc(db, "users", result.user.uid);
      const userDoc = await getDoc(userDocRef);
      if (!userDoc.exists()) {
        console.log("Añadiendo doc a firestore del nuevo usuario...");
        createUserDoc(result.user);
      }

    } catch (error) {
      setError(error.message);
    }
  };

  //Cambio de pantalla a la de Registro (OCULTO POR AHORA)
  const handleRegister = () => {
    try {
      navigate("/register");
    } catch (error) {
      setError(error.message);
    }
  }

  //Gestiona el login mediante correo y contraseña
  const handleEmailAuth = async (e) => {
    e.preventDefault();
    try {
      //la sesión sólo dura hasta que se cierra el browser
      await setPersistence(auth, browserSessionPersistence);
      
      await signInWithEmailAndPassword(auth, email, password);
      //una vez loggeado se navega a la página principal
      navigate("/");
    } catch (error) {
      setError(error.message);
    }
  };
  /***********************************************************************************************/
  /***********************************************************************************************/

  //Se ha ocultado la sección para Registrarse

  return (
    <div>
      <div className="panel left-panel">
        <div className="left-panel-sub">
          <div className="texto-titulo">Mixoutfit:</div>
          <div className="texto-titulo-2">Transforma tu Ecommerce con AI</div>
          <div className="texto-subtitulo">Crea cientos de fotos con modelos generados por IA en segundos y en tiempo récord</div>
          <p></p>
          <video className="video" autoPlay muted loop>
            <source src="/video/ejemplo-uso.mp4" type="video/mp4"/>
            El navegador no soporta el display de video.
          </video>
          <p></p>
          <button className="boton-updates">LATEST UPDATES</button>
          <p></p>
          <div className="texto-normal">¡Da el salto al futuro con tu nueva Aplicación!</div>
          <p></p>
        </div>
      </div>

      <div className="panel right-panel">
        <img src={MixrealLogo} alt="Logo" className="logo" />
        <div className="titulo-sesion">Inicia sesión en tu cuenta</div>
				<p className="espacio"></p>
        <form onSubmit={handleEmailAuth}>
        <div className="container-caja">
          <Mail className="icono-caja" />
          <input
            type="email"
            className="caja-texto"
            placeholder="Nombre@ejemplo.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <p className="espacio"></p>
        <div className="container-caja">
          <LockKeyhole className="icono-caja" />
          <input
            type={showPassword ? "text" : "password"}
            className="caja-texto"
            placeholder="Introduce tu contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="button" onClick={togglePasswordVisibility} className="boton-caja-derecha">
            {showPassword ? <Eye className="icono-caja-derecha"/> : <EyeOff className="icono-caja-derecha"/>}
          </button>
        </div>
        <p className="espacio"></p>
        <button type="submit" className="boton-iniciarsesion">Iniciar sesión</button>
        </form>
        {/* Sección registro y login con proveedores externos */}
        {/* <p className="espacio"></p>
        <div className="container-registro">
					<div className="texto-normal">¿No tienes cuenta?</div>
					<span 
						onClick={() => handleRegister()} 
						className="texto-registro"
					>Regístrate aquí</span>
        </div>
				<p className="espacio"></p>
				<div className="separator">
					<span className="line-separator"></span>
					<span className="texto-separator">O</span>
					<span className="line-separator"></span>
				</div>
				<p className="espacio"></p>
        <div className="container-botones-auth">
					<button onClick={handleGoogleLogin} className="boton-auth">
						<img src={GoogleIcon} alt="Google logo" className="icon" />
						Google
					</button>
					<button onClick={handleMicrosoftLogin} className="boton-auth">
						<img src={MicrosoftIcon} alt="Microsoft logo" className="icon" />
						Microsoft
					</button>
					<button onClick={handleFacebookLogin} className="boton-auth">
						<img src={FacebookIcon} alt="Facebook logo" className="icon" />
						Facebook
					</button>
        </div>*/}
				<p className="espacio"></p>
        {error && <p className="error-message">{error}</p>}
				<p className="espacio"></p>
        <div className="texto-separator">
        Al registrarte en la plataforma Mixreal, comprendes y aceptas nuestros 
				Términos y condiciones y Política de privacidad. Este sitio está protegido por 
				Google reCAPTCHA para garantizar que no seas un robot. Más información
        </div>
      </div>
    </div>
  );
};

export default Login;